export class Examen {
  constructor(
    public id: number,
    public nroLibreta: number,
    public idGraduacion: number,
    public fcExamen: string,
    public isEditMode: boolean = false,
    public disableValidation: boolean = false
  ) {
    if (!disableValidation && (!nroLibreta || !idGraduacion || !fcExamen)) {
      throw new Error("nroLibreta, idGraduacion, and fcExamen are required fields");
    }
  }

  static fromRows(rows: any[]): Examen[] {
    return rows.map(row => Examen.fromApiData(row));
  }

  static fromApiData(data: any): Examen {
    return new Examen(
      data.id,
      data.nroLibreta,
      data.idGraduacion,
      data.fcExamen,
      false,
      false
    );
  }

  fill(newFields: Partial<Examen>): void {
    for (let field in newFields) {
      if (this.hasOwnProperty(field) && newFields.hasOwnProperty(field)) {
        const key = field as keyof Examen;
        if (this[key] !== undefined) {
          (this[key] as any) = newFields[key]!;
        }
      }
    }
  }

  toJSON() {
    return {
      id: this.id,
      nroLibreta: this.nroLibreta,
      idGraduacion: this.idGraduacion,
      fcExamen: this.fcExamen
    };
  }
}